import React, { useEffect, useState } from 'react';
import HelpBackIcon from './../../../../../images/helpbackicon.png'
import {Link, useNavigate} from 'react-router-dom'

function ProfileUpdates() { 
    const [feedback,setFeedback] = useState(false)
    const navigate= useNavigate();

    return (
        <div style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yovww6fxrbmtzfqlpy0z")`,backgroundPositionX:'-1em',backgroundSize:'100%'}}>

        <div style={{         
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        zIndex:'1',
        height:'9.63em'
        }}/>

        <div style={{
              backgroundColor:'#F9FCFF',
              width:'100%',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              paddingBottom:'5.5em',
              minHeight: '72vh', height: 'auto'
        }}>
            <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'flex-start',
                width:'70%',
                paddingTop:'2.5em'
            }}>

                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    cursor:'pointer'
                   
                }} onClick={()=>{navigate("/help");setFeedback(false)}}>
                    <img src={HelpBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em',cursor:'pointer'}}/>
                    <div className="backTxt">Back</div>
                </div>

                <div className="infoHeader">
                Profile Updates
                </div>

                <div className="infoDescHeader">
                NOTIFICATION SETTINGS
                </div>

                <div className="infoDesc">
                In Settings, you can access your notification settings. This tab allows you to opt in to email notifications that help keep you up date with important updates and alerts about your account. 
                </div>

                <div className="infoDesc">
                We recommend turning the notifications feature on to help keep your finger on the pulse of your account.
                </div>

                {
                    !feedback &&
                    <div>
                         <div className="infoDesc" style={{marginTop:'6.5em'}}>
                            Was this article helpful?
                            </div>

                            <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    YES
                                </div>

                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    NO
                                </div>
                            </div>
                    </div>
                }

                {
                    feedback &&
                    
                         <div className="infoDesc" style={{marginTop:'8.5em'}}>
                           Thank you for your feedback
                            </div>

                         
                    
                }
               
            </div>

        </div>
        
        
       
    </div>
    )
}


export default ProfileUpdates;